module.exports = new __parcel__URL__("Retro Hover.fbb2e555.svg").toString();